'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwTable = require('./CwTable.scss');

var _CwTable2 = _interopRequireDefault(_CwTable);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwTable = function CwTable(props) {
  var _cx;

  var className = (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, props.className, props.className), (0, _defineProperty3.default)(_cx, _CwTable2.default.nested, props.nested), _cx), props.alternatingRowColors ? _CwTable2.default.tableAlternateRow : _CwTable2.default.table);
  return _react2.default.createElement(
    'table',
    { style: props.style, className: className },
    props.children
  );
};

CwTable.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes2.default.string,
  /**
   * Override the styles of the root element
   */
  style: _propTypes2.default.object,
  /**
   * Set to false if alternating row colors are not desired
   */
  alternatingRowColors: _propTypes2.default.bool,
  /**
   * Whether the table is a nested table and requires different styles.
   */
  nested: _propTypes2.default.bool
};

CwTable.defaultProps = {
  alternatingRowColors: true
};

exports.default = CwTable;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwtable/CwTable.js
// module id = 380
// module chunks = 10